import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { useReportMonk } from "../../context/reportMonk";

import { getLastReward } from "../../utils/reward";
import { fontFamiliy } from "./constant";

const WeekTotalScore = () => {
  const { haveRewards, getCurrentWeekLastReward, getCurrentWeekTotal4D } =
    useReportMonk();

  const getImage = (imageName) => {
    return require("../../assets/images/badges/" + imageName);
  };

  return (
    <TotalScoreCard>
      <Container>
        <ColumnContainer style={{ width: "45%" }}>
          {haveRewards() && getCurrentWeekLastReward() != null && (
            <img
              src={getImage(getLastReward(getCurrentWeekLastReward()).image)}
              style={{ width: "130px" }}
            />
          )}
        </ColumnContainer>
        <ColumnContainer style={{ width: "55%" }}>
          {haveRewards() && getCurrentWeekLastReward() != null && (
            <>
              <LabelTop>ท่านทำถึงเป้าหมายแล้ว</LabelTop>
              <br />
              <LabelTop2>
                {getLastReward(getCurrentWeekLastReward(), "name")}
              </LabelTop2>
            </>
          )}
          <br />
          <TotalScore>{getCurrentWeekTotal4D("-")}</TotalScore>
          <TotalScoreLabel>คะแนนรวม 4 เป้าหมาย</TotalScoreLabel>
        </ColumnContainer>
      </Container>
    </TotalScoreCard>
  );
};

const TotalScoreCard = styled.div`
  font-family: ${fontFamiliy}
  height: 120px;
  width: 340px;
  margin-top: 24px;
  background: #ffffff;
  /* Shadow (XS) */

  box-shadow: 0px -7px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px 8px 0px 0px;

  padding-left: 16px;
  padding-right: 15px;
  padding-top: 10px;
  padding-bottom: 16px;
`;

const Container = styled.div`
  display: flex;
  height: 100%;
`;

const ColumnContainer = styled.div`
  height: 100%;
`;

const LabelTop2 = styled.span`
  font-family: ${fontFamiliy}
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  /* identical to box height, or 133% */

  /* Secondary/400 */

  color: #fc6b4b;
`;

const LabelTop = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 26px;
  /* identical to box height, or 173% */

  /* Neutral / 500 */

  color: #64748b;
`;

const RewardName = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  /* identical to box height, or 133% */

  /* Secondary/400 */

  color: #fc6b4b;
`;

const TotalScore = styled.div`
  float: right;
  width: 100px;
  height: 46px;
  /* Secondary/500 */

  background: #fb633d;
  border-radius: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 26px;
  /* identical to box height, or 108% */

  text-align: center;

  /* Shades/White */

  color: #ffffff;
  padding-top: 11px;
  margin-right: 8px;
  margin-top: 4px;
  margin-left: 4px;
`;

const TotalScoreLabel = styled.span`
  font-family: ${fontFamiliy}
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* or 133% */

  /* Neutral / 600 */

  color: #4b5768;
`;

export default WeekTotalScore;
